"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sharp = void 0;
exports.sharp = {
    button: "md",
    accordion: "md",
    annonce: "xl",
    avatar: "full",
    badge: "md",
    card: "md",
    flag: "md",
    field: "DEFAULT",
    popover: "md",
    tooltip: "md",
    menu: "md",
    alert: "md",
    switch: "md",
    toast: "md",
    tabs: {
        default: "md",
        soft: "md",
        bottomIndicator: "md",
    },
};
exports.default = exports.sharp;
